export function isEmbed(): boolean {
  return window !== window.top;
}
